/**
 * The product's name as people read it: every screen, message, email and authenticator entry
 * built in code takes it from here (ticket #148). The owner adopted PlantelGO on 2026-09-27 "for
 * now"; the trademark search left GoPlantel as the alternative, so a rename starts here, then the
 * wordmark and its accessible name in `packages/ui/src/components/brand` and the static files
 * listed in `docs/brand.md`. The legal entity stays "ClassGO S.A.S." and technical names
 * (packages, AWS resources, domains) do not follow this constant.
 */
export const PRODUCT_NAME = 'PlantelGO';
